import { render } from "./ResetPasswordDialog.vue?vue&type=template&id=e05af026"
import script from "./reset-password-dialog-component.ts?vue&type=script&lang=js&external"
export * from "./reset-password-dialog-component.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__